import { render } from "./WorkbookNotices.vue?vue&type=template&id=0f125543"
import script from "./WorkbookNotices.vue?vue&type=script&lang=js"
export * from "./WorkbookNotices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__